import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PageRequest, PaginationPage } from 'src/app/common/modules/data-table.module/interfaces';
import { DashboradPaiementPatient } from 'src/app/entities/dashborad-paiement-patient.entity/dashborad-paiement-patient';
import { User } from 'src/app/entities/user.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';
import { environment } from 'src/environments/environment';
interface PatientVM extends DashboradPaiementPatient {
  _initials:        string;
  _totalAmount:     number;
  _resteAmount:     number;
  _progressPercent: number;
}
@Component({
  selector: 'app-dashborad-paiement-patient',
  templateUrl: './dashborad-paiement-patient.component.html',
  styleUrls: ['./dashborad-paiement-patient.component.css'],
})

export class DashboradPaiementPatientComponent implements  OnInit {
  @Input() headers: Array<{ label: string; sorted?: { key: string; order: number } }> = [
    { label: "Dossier N° " },
    { label: "Patient" },
        {label:"Rendez-vous"},

    { label: "Consultation" },
    { label: "Actes" },
    { label: "Total" },
    { label: "Payé" },
    { label: "Balance" },
  ];

  @Input() currentPage: number = 0;
  @Input() perPage: number = 10;
  @Input() pageRequest!: (pageRequest: PageRequest) => Promise<PaginationPage<any>>;
  @Output() onAssignAppointmentRequest: EventEmitter<any> = new EventEmitter();
  @Output() onAntecedentsRequest: EventEmitter<any> = new EventEmitter();
  @Output() onUpdateRequest: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteRequest: EventEmitter<any> = new EventEmitter();
  @Output() onPrescriptionsRequest: EventEmitter<any> = new EventEmitter();
  @Output() onConsultationsRequest: EventEmitter<any> = new EventEmitter();

  @Output() onRefresh: EventEmitter<PageRequest> = new EventEmitter();

  @Input() actions: Partial<{
    edit: boolean;
    delete: boolean;
    assignAppointment: boolean;
    prescriptionsView: boolean;
    consultationsView: boolean;
    antecentendsView: boolean;
    payementsView: boolean;
    badge: boolean;
  }> = {};
  @Input() emptyMessage?: string;
 avatarSrc(dashboradPaiementPatient: DashboradPaiementPatient): string {
    return dashboradPaiementPatient.patientImageProfile ? `http${environment.API_SSL ? 's' : ''}://${environment.API_HOST_NAME}${environment.PORT ? ':' + environment.PORT : ''}/${environment.STORAGE_ENDPOINT}/${dashboradPaiementPatient.patientImageProfile}` : 'assets/img/user-avatar.png';
  }
  date: number = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
  paiements: Array<any> = new Array();

  sortedheadIndex: number = -1;

  get hasActions(): boolean {
    return Object.values(this.actions).some((e) => e == true);
  }
  constructor(private authService: AuthService) {}

  get currentUser(): User {
    return this.authService.getCurrentUser()!;
  }

  ngOnInit(): void {
    this.currentPage = 0;
  }

  onSortRequested(headIndex: number, key: string): void {
    if (headIndex == this.sortedheadIndex) {
      this.sortedheadIndex = -1;
      this.onRefresh.emit();
    } else {
      this.sortedheadIndex = headIndex;
    }
  }

  onDelete(index: number): void {}
}
